import { forwardRef, type Ref, type SVGProps } from "react";
const IconSquareFeetFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m29.39 25.56-24-22A1.98 1.98 0 0 0 4.01 3H4a2.005 2.005 0 0 0-2 2v23a1.003 1.003 0 0 0 1 1h25a1.99 1.99 0 0 0 2-2 1.92 1.92 0 0 0-.61-1.44M8 26.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V25a1 1 0 0 1 2 0Zm5 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V25a1 1 0 0 1 2 0ZM10 21v-5l5 5Zm8 5.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V25a1 1 0 0 1 2 0Zm5 0a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V25a1 1 0 0 1 2 0Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSquareFeetFilledSVG);
ForwardRef.displayName = "IconSquareFeetFilled";
export { ForwardRef as IconSquareFeetFilled };
